import React from "react";
import Header from "./Header";

type Props = {
  title?: string;
};

const Loader = ({ title = "Loading..." }: Props) => {
  return (
    <>
      <Header />
      <div className='container-body login'>{title}</div>
    </>
  );
};

export default Loader;
